import moment from 'moment';
import idle from 'idle-js';
import { forEach } from 'lodash';

export default class TimeUtil {
    /* @ngInject */
    constructor($timeout, numberUtil) {
        this.$timeout = $timeout;
        this.numberUtil = numberUtil;

        this.units = [
            'year',
            'month',
            'week',
            'day',
            'hour',
            'minute',
            'second'
        ];
    }

    now() {
        return moment().valueOf();
    }

    toTransactionDate(timestamp) {
        return moment(timestamp).format('YYYY-MM-DD');
    }

    isWeekend(timestamp) {
        return moment(timestamp).isoWeekday() > 5;
    }

    getWeekdays(startOfWeek) {
        let start = moment().startOf('isoWeek').add(fixStartOfWeek(startOfWeek) - 1, 'day');

        let days = [];
        for (let index = 0; index < 7; ++index) {
            let timestamp = moment(start).add(index, 'day').valueOf();

            days.push({
                timestamp,
                weekend: this.isWeekend(timestamp)
            });
        }

        return days;
    }

    getDaysForMonth(date, startOfWeek, count) {
        let daysFromPreviousMonth = this.getDaysCountFromPreviousMonth(date, startOfWeek);
        
        date = moment(date).startOf('month');
        let start = moment(date).subtract(daysFromPreviousMonth, 'day');
        let daysInCurrentMonth = date.daysInMonth();

        count = this.numberUtil.isInteger(count) ? count : 7 * Math.ceil((daysFromPreviousMonth + daysInCurrentMonth) / 7);

        let today = moment(this.now()).startOf('day').valueOf();

        let days = [];

        for (let index = 0; index < count; ++index) {
            date = moment(start).add(index, 'day').startOf('day');
            let timestamp = date.valueOf();

            days.push({
                timestamp,
                previous: index < daysFromPreviousMonth,
                next: index >= daysInCurrentMonth + daysFromPreviousMonth,
                today: today === moment(timestamp).startOf('day').valueOf(),
                weekend: this.isWeekend(timestamp)
            });
        }

        return days;
    }

    getDaysCountFromPreviousMonth(date, startOfWeek) {
        return moment(date).startOf('month').isoWeekday() - fixStartOfWeek(startOfWeek) % 7;
    }
}

function fixStartOfWeek(startOfWeek) {
    return startOfWeek === 0 || startOfWeek === 1
        ? startOfWeek
        : 0;
}

let isIdle = false;
let callbacks = {};

let idler = new idle({
    idle: 1000 * 30,
    onIdle: idleCallback,
    onActive: activeCallback,
    onHide: idleCallback,
    onShow: activeCallback
});
idler.start();

export function every(unit, callback) {
    const now = moment().valueOf();
    const date = moment(getNextTimestampByUnit(now, unit));
    
    const id = setTimeout(() => {
        if (isIdle) {
            return onActive(id, next);
        }

        return next();
    }, moment(date).diff(now));

    let clear = () => {
        removeJob(id);
        clearTimeout(id);
    };
    let next = () => {
        clear = every(unit, callback);
        callback();
    };

    return () => clear();
}

function getNextTimestampByUnit(start, unit) {
    return moment(start).add(1, unit).startOf(unit).valueOf();
}

function idleCallback() {
    isIdle = true;
}

function activeCallback() {
    isIdle = false;

    forEach(callbacks, (callback) => callback());

    callbacks = {};
}

function onActive(id, callback) {
    callbacks[id] = callback;
}

function removeJob(id) {
    delete callbacks[id];
}

export function getNow() {
    return moment().valueOf();
}

export function getToday() {
    return moment(getNow()).startOf('day').valueOf();
}



// WEBPACK FOOTER //
// ./src/application/util/time.util.js